import { render, staticRenderFns } from "./AuthApply.vue?vue&type=template&id=22b9d226"
import script from "./AuthApply.vue?vue&type=script&lang=js"
export * from "./AuthApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports